import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import EmailToJourneyEditModal from 'src/components/admin/email-to-journey/components/email-to-journey-edit-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { BUSFINDER_UI_URL, Entities } from 'src/common';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import moment from 'moment';

class EmailToJourneyAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { emailToJourneyItems } = nextProps;

        if (emailToJourneyItems.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(emailToJourneyItems.items.length);
    }
    componentWillMount() {
        this.props.fetchAll(Entities.EMAIL_TO_OFFER);
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.emailToJourneyItems,
                this.props.emailToJourneyItems,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { emailToJourneyItems } = this.props;
        const tableData = [];
        const finishFetching = this.state.startedFetching && !emailToJourneyItems.isFetching;

        if (finishFetching && emailToJourneyItems.items.length > 0) {
            emailToJourneyItems.items.map(entry => {
                tableData.push({
                    id: entry.id,
                    createdAt: moment(entry.createdAt).format('DD.MM.YYYY HH:mm:ss'),
                    token: entry.token,
                });
            });
        }

        const { t } = this.props;
        return (
            <>
                <legend className="legend">{t('email_to_journey.title')}</legend>
                <button
                    className="btn btn-xs btn-blue btn-flex pull-right"
                    onClick={() => {
                        if (this.table) this.table.reset();
                        this.props.openModal({
                            component: EmailToJourneyEditModal,
                            componentProps: {
                                isCreate: true,
                                refetch: () => this.props.fetchAll(Entities.EMAIL_TO_OFFER),
                            },
                            title: t('email_to_journey.title'),
                            noButtons: true,
                        });
                    }}>
                    <span className="glyphicon glyphicon-plus" />
                    {t('email_to_journey.request')}
                </button>
                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        ref={ref => (this.table = ref)}
                        data={tableData}
                        exportCSV={true}
                        striped={true}
                        hover={true}
                        condensed={true}
                        pagination={true}
                        options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                        searchPlaceholder={t('common_phrases.search')}
                        search={true}>
                        <TableHeaderColumn
                            columnTitle={true}
                            dataField="id"
                            hidden={false}
                            width="30"
                            isKey={true}
                            export={true}>
                            {t('common_phrases.id')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="50" dataField="createdAt" dataSort={true}>
                            {t('find_my_bus.requested')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="actions"
                            width="90"
                            dataFormat={this.tableActionsFormatter}
                            export={false}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </>
        );
    }

    tableActionsFormatter(cell, row) {
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        window.open(`${BUSFINDER_UI_URL}/journey-planning?emailToJourneyToken=${row.token}`);
                    }}>
                    <span className="glyphicon glyphicon-log-out text-info" />
                </button>
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(EmailToJourneyAdministration));
